import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../context/LangContext';
import { useCart } from '../context/CartContext';
import { fixImageUrl, PLACEHOLDER_IMG, UNIT_CONFIG, formatUnit } from '../lib/format';
import Button from '../lib/ui/Button';
import { EmptyState } from '../lib/ui/Feedback';

export default function CartContent({ onCheckout }) {
  const { lang, t } = useLang();
  const te = lang === 'te';
  const { cart, updateQty, removeItem, total } = useCart();
  const navigate = useNavigate();

  const goCheckout = onCheckout || (() => navigate('/checkout'));

  if (cart.length === 0) {
    return (
      <div className="py-10">
        <EmptyState icon="🛒" title={t.cartEmpty} action={<Button onClick={() => navigate('/')}>{te ? 'షాపింగ్ ప్రారంభించండి' : 'Start Shopping'}</Button>} />
      </div>
    );
  }

  return (
    <div>
      <div className="divide-y divide-black/5">
        {cart.map((item) => {
          const cfg = UNIT_CONFIG[item.unit] || UNIT_CONFIG.kg;
          const step = cfg.step;
          const lbl = formatUnit(item.quantity_kg, item.unit);
          return (
            <div key={item.product_id} className="flex items-center gap-3 py-3.5">
              <img
                src={fixImageUrl(item.image_url) || PLACEHOLDER_IMG}
                alt={te ? item.product_name_te : item.product_name}
                onError={(e) => { e.target.onerror = null; e.target.src = PLACEHOLDER_IMG; }}
                className="h-14 w-14 rounded-xl object-cover shrink-0 bg-brand-light/40"
              />
              <div className="flex-1 min-w-0">
                <div className="font-extrabold text-sm text-ink truncate">{te ? item.product_name_te : item.product_name}</div>
                <div className="text-xs text-ink-faint mt-0.5">₹{item.price_per_kg}/{cfg.label}</div>
                <div className="flex items-center gap-2.5 mt-1.5">
                  <button
                    type="button"
                    onClick={() => updateQty(item.product_id, parseFloat((item.quantity_kg - step).toFixed(2)))}
                    className="h-7 w-7 rounded-lg bg-brand-light text-brand-dark font-black border border-brand/30"
                  >−</button>
                  <span className="min-w-[52px] text-center font-extrabold text-sm">{lbl}</span>
                  <button
                    type="button"
                    onClick={() => updateQty(item.product_id, parseFloat((item.quantity_kg + step).toFixed(2)))}
                    className="h-7 w-7 rounded-lg bg-brand-light text-brand-dark font-black border border-brand/30"
                  >+</button>
                </div>
              </div>
              <div className="flex flex-col items-end gap-1.5 shrink-0">
                <span className="font-black text-brand-dark">₹{item.subtotal.toFixed(0)}</span>
                <button type="button" onClick={() => removeItem(item.product_id)} className="text-red-500 text-base">🗑</button>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-4 bg-gradient-to-br from-brand-light/70 to-gold-light/50 rounded-2xl p-4">
        <div className="flex items-center justify-between mb-3">
          <span className="font-bold text-ink-soft">{t.total}</span>
          <span className="font-black text-2xl text-brand-dark">₹{total.toFixed(2)}</span>
        </div>
        <Button variant="accent" fullWidth size="lg" onClick={goCheckout}>{t.confirmOrder} →</Button>
      </div>
    </div>
  );
}
